export default ($window, $translate, MomentService) => {
    const filter = (deadline, previousPassedTime, isInfiniteDeadline = false) => {
        if (deadline) {
            return MomentService.formatDate(deadline);
        }

        if (previousPassedTime && isInfiniteDeadline) {
            return `<br><small>${$translate.instant('course.user.Does not expire')}</small>`;
        }

        return '-';
    };

    filter.$stateful = true;

    return filter;
};



// WEBPACK FOOTER //
// ./src/app/filters/personalDeadline/index.js